/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { useQuery } from "@tanstack/react-query";

import { isFarmlandsProApiAccountNumberApplied } from "../../../../services/farmlandspro-api";
import { Product } from "../../storage/types";
import { getActivePricesForPastProducts } from "../productsApi";

export const getActivePricesForPastProductsQueryKey = (
  accountNumber: string | undefined,
  productIds: number[],
  branchId: string | undefined
) => ["active-prices-past-products", accountNumber, branchId, ...productIds] as const;

export const usePastProductsWithActivePrices = (
  accountNumber: string | undefined,
  products: Product[],
  branchId: string | undefined
) => {
  const productIds = products.map((product) => product.productId);

  return useQuery({
    queryKey: getActivePricesForPastProductsQueryKey(accountNumber, productIds, branchId),
    queryFn: () => getActivePricesForPastProducts(accountNumber, products, branchId),
    enabled: isFarmlandsProApiAccountNumberApplied(accountNumber) && products.length > 0,
    placeholderData: (previousData) => previousData,
  });
};
